import React from 'react';

import PropTypes from 'prop-types';

import { Text } from '@adsk/alloy-react-box';
import { useLocale } from '@adsk/alloy-react-locale';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useUserData } from '../../hooks';

export enum SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
}

interface AssigneeCellProps {
  userId: string;
  stacked?: boolean;
  size?: SIZES;
}

const AssigneeDisplay: React.FC<AssigneeCellProps> = ({
  userId,
  stacked,
  size,
}) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const user = useUserData(userId);

  const typographyType = size === SIZES.SMALL ? 'bodySmall' : 'bodyMedium';

  if (!user.name) {
    if (user.isLoading) {
      return <span>{T.translate('LOADING')}</span>;
    } else {
      return <Text color="charcoal500">{T.translate('FORMER_MEMBER')}</Text>;
    }
  }

  const { name, company } = user;

  const tooltipContent = (
    <div>
      <div>{name}</div>
      <div>{company}</div>
    </div>
  );
  return (
    <OverflowTooltip content={tooltipContent} autoTipOnEllipsis>
      <Text typography={typographyType}>{name}</Text>
      {company &&
        (stacked ? (
          <>
            <br />
            <Text color="charcoal700" typography={typographyType}>
              {company}
            </Text>
          </>
        ) : (
          <Text marginLeft="4px" typography={typographyType}>
            ({company})
          </Text>
        ))}
    </OverflowTooltip>
  );
};

AssigneeDisplay.displayName = 'SubmittalsAssigneeDisplay';
AssigneeDisplay.propTypes = {
  userId: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(SIZES)).isRequired,
  stacked: PropTypes.bool,
};
AssigneeDisplay.defaultProps = {
  stacked: false,
  size: SIZES.MEDIUM,
};

export default AssigneeDisplay;
